module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// C:/Source/hackathon/hackathon/web-app/node_modules/core-js/library/modules/_redefine.js
// module id = 119
// module chunks = 0